export default {
  CHANNEL_KEY: `${process.env.NODE_ENV || "production"}/channelInfo`,

  setChannelInfo(channelInfo) {
    if (channelInfo) {
      sessionStorage.setItem(this.CHANNEL_KEY, JSON.stringify(channelInfo));
    }
  },

  getChannelInfo(name) {
    const jsonStr = sessionStorage.getItem(this.CHANNEL_KEY);
    if (jsonStr) {
      const data = JSON.parse(jsonStr) || {};
      return name ? data[name] : data;
    }
    return null;
  },
};
